import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../../../constants/constants";
import TblComp from "../../../../../react_table";
import { Button } from "reactstrap";
import {
  HandleTransactionTypeFetch,
  editTransactionType,
  HandleTransactionTypeDelete,
} from "../../../../../actions/settings/types/transaction_type_actions";
import ExportCSV from "../../../../../constants/Exports/xlsExport";
import { clearTransactionTypeForm } from "../../../../../actions/settings/types/transaction_type_actions";
import DeleteModal from "../../../../../constants/deleteModal";

export const TransactionTypesTable = (props) => {
  const [modal, setModal] = useState(false);
  const [selected, setSelected] = useState(false);
  const toggle = () => setModal(!modal);
  const dispatch = useDispatch();
  const { loading_trans_types, transaction_type_list, is_processing } =
    useSelector((state) => state.transactiontypereducer, shallowEqual);
  useEffect(() => {
    transaction_type_list.length === 0 &&
      dispatch(HandleTransactionTypeFetch());
  }, [dispatch, transaction_type_list.length]);

  const headers = ["Id", "Title", "Description"];
  return (
    <>
      <DeleteModal
        modal={modal}
        toggle={toggle}
        name="transaction type"
        handleDelete={() =>
          dispatch(HandleTransactionTypeDelete(selected, toggle))
        }
        is_processing={is_processing}
      />
      <Button
        className="btn ticket-btn my-3 me-2"
        onClick={(e) => {
          dispatch(clearTransactionTypeForm(e));
          props.toggle();
        }}
      >
        Add Transaction Type
      </Button>
      <ExportCSV
        csvData={transaction_type_list}
        fileName="transactiontypes"
        headers={headers}
      />

      <TblComp
        columns={[
          { Header: "Title", accessor: "title", filter: "fuzzyText" },
          {
            Header: "Description",
            accessor: "description",
            filter: "fuzzyText",
          },
          {
            id: "actions", // Required because our accessor is not a string
            Header: "Action",
            maxWidth: 100,
            accessor: (full) => (
              <Actions
                editHandler={(selected_row) => [
                  dispatch(editTransactionType(selected_row)),
                  props.toggle(),
                ]}
                data_item={full}
                link_url={""}
                deleteHandler={(selected_id) => [
                  toggle(),
                  setSelected(selected_id.id),
                ]}
              />
            ),
          },
        ]}
        data={transaction_type_list}
        loading={loading_trans_types}
      />
    </>
  );
};
